import React from "react";
import "./TutorialPopup.css"; // Assurez-vous d'importer le CSS

const TutorialPopup = ({
  content,
  onNext,
  position,
  isVisible,
  onClose,
  txUrl,
  showArrow, // Nouvelle prop pour contrôler la pointe
  tmpNextLabel,
  tmpCloseLabel,
}) => {
  if (!isVisible) return null;

  let showDataLabel = 'Voir les données sur la blockchain';
  let nextLabel = "Continuer";
  let closeLabel = "Fermer le tutoriel";

  return (
    <div className="tutorial-popup" style={position}>
      {showArrow && showArrow!=="right" && <div className="tutorial-popup-arrow-left"></div>}
      {showArrow && showArrow==="right" && <div className="tutorial-popup-arrow-right"></div>}
      <div className="tutorial-content">{content}</div>
      {txUrl && (
        <div className="tutorial-actions-tx">
          <button
            className="btn btn-primary"
            onClick={(e) => {
                e.preventDefault();
                window.open(txUrl, "_blank", "noopener,noreferrer")
            }}
          >
            {showDataLabel}
          </button>
        </div>
      )}
      <div className="tutorial-actions">
        {
            tmpCloseLabel!=="hidden" && (
                <button className="btn btn-primary" onClick={onClose}>
                {tmpCloseLabel || closeLabel}
              </button>
            )
        }
        <div className="blank_button"></div>
        <button className="btn btn-primary" onClick={onNext}>
          {tmpNextLabel || nextLabel}
        </button>
      </div>
    </div>
  );
};

export default TutorialPopup;
